import { gql } from '@apollo/client'
import { POST_ITEM_FIELDS_FORLIST, POST_ITEM_USER } from './fragments'

export const GET_TABS = gql`
  fragment AiModelTabFragment on AiModelTab {
    idStr
    englishName
    icon
    isLeaf
    isRadio
    name
    tabExtra {
      artistImage
      artworkImage
      description
    }
    tabType
  }
  query getTabs($isSimple: Boolean = false) {
    aiArtworkResourceModule {
      aiSquareTab {
        tab {
          child {
            child @skip(if: $isSimple) {
              child {
                child {
                  ...AiModelTabFragment
                }
                ...AiModelTabFragment
              }
              ...AiModelTabFragment
            }
            ...AiModelTabFragment
          }
          ...AiModelTabFragment
        }
      }
    }
  }
`

export const SEARCH = gql`
  ${POST_ITEM_FIELDS_FORLIST}
  ${POST_ITEM_USER}
  query search(
    $first: Int
    $endCursor: String
    $param: CopyrightAiTextSearchParam
  ) {
    aiArtworkResourceModule {
      wjAiTextSearch(
        page: { first: $first, after: $endCursor, pattern: CURSOR }
        param: $param
      ) {
        edges {
          node {
            ...postItemFieldsForList
            type
            ... on SquarePost {
              visible
              user {
                ...postItemUser
              }
              type
              status
              #是否被推荐
              recommend
              competitionStyle # 大赛作品样式展示 null则表示未参赛 0-参赛 其余值表示排名
              artwork {
                id # 大赛作品id
              }
              aiCollection {
                aiArtworkCount
                coverAiArtworks {
                  id
                  miniArtWorkUrl
                }
              }
              specialImage {
                image {
                  imageUrl
                }
                tagEnum
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          totalCount
          endCursor
        }
      }
    }
  }
`

export const GET_HOT_KEYWORD = gql`
  query getHotKeyword {
    aiArtworkResourceModule {
      hotKeywordList
    }
  }
`

export const IMAGE_SEARCH_PAGE = gql`
  ${POST_ITEM_FIELDS_FORLIST}
  ${POST_ITEM_USER}
  query imageSearchImage($offset: Int, $first: Int, $imageUrl: String) {
    aiArtworkResourceModule {
      imageSearchPage(
        page: { first: $first, offset: $offset }
        imageUrl: $imageUrl
      ) {
        edges {
          node {
            ...postItemFieldsForList
            ... on SquarePost {
              user {
                ...postItemUser
              }
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`

export const GET_SIZES = gql`
  query getSizes {
    aiArtworkResourceModule {
      sizeList
    }
  }
`

export const GET_ARTWORK_MODELS = gql`
  query getArtworkModels($model: AiCreateArtworkModel) {
    aiArtworkResourceModule {
      modelClassificationList(aiArtworkModel: $model) {
        ids
        name: showName
      }
    }
  }
`
export const GET_VISIBLE_LIST = gql`
  query getVisibleList {
    squareModule {
      postVisibleTypeList {
        desc
        value
      }
    }
  }
`

export const GET_STYLES_MODELS = gql`
  query getStyleModels {
    pictureGraph {
      styleModelList {
        name
        key
      }
    }
  }
`

/** 获取banner */
export const GET_HOME_BANNER_LIST = gql`
  query getHomeBannerList($scene: Int) {
    marketingModule {
      bannerList(scene: $scene) {
        id
        title
        redirectUrl
        imageUrl
        startDateTime: startTime
        sort
      }
    }
  }
`

/** 获取当前弹窗广告详情 */
export const GET_CURRENT_ADV_DIALOG = gql`
  query getCurrentAdvDialog {
    marketingModule {
      currentPopup {
        channelList
        endTime
        frequency
        id
        image
        needLogin
        pv
        startTime
        status
        uv
        webLink
      }
    }
  }
`

/** 点击 当前弹窗广告 */
export const CLICK_CURRENT_ADV_DIALOG = gql`
  mutation clickCurrentAdvDialog($id: Long) {
    marketingModule {
      succeed: popupClick(id: $id)
    }
  }
`
